import * as React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

export const SvgIcon = styled.svg`
  margin-top: -0.105em;
  margin-bottom: -0.145em;
  height: 1.25em;
  width: 1.25em;
  vertical-align: -0.185em;
`

export function Add() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </SvgIcon>
  )
}

export function ArrowRightAlt() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
    </SvgIcon>
  )
}

export function BankNote() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M2,5v14h20V5H2z M9,17l-5-5V7h11l5,5v5H9z" />
      <circle fill="currentColor" cx="12" cy="12" r="3" />
    </SvgIcon>
  )
}

export function CoinStack() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.086,5C4.562,4.595,6.216,4,8,4s3.438,0.595,3.914,1H14c0-2.243-4.121-3-6-3S2,2.757,2,5v12c0,2.245,4.121,3,6,3c0.287,0,0.631-0.021,1-0.058v-2.009C8.675,17.974,8.342,18,8,18c-1.916,0-3.682-0.684-4-1.086v-0.693C5.32,16.776,6.985,17,8,17c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,14.974,8.342,15,8,15c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,13.776,6.985,14,8,14c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,11.974,8.342,12,8,12c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,10.776,6.985,11,8,11c0.288,0,0.631-0.021,1-0.058V8.934C8.675,8.974,8.342,9,8,9C6.063,9,4.291,8.303,4,7.902V7.221C5.32,7.776,6.985,8,8,8c0.288,0,0.631-0.021,1-0.058V5.935C8.675,5.974,8.342,6,8,6C6.216,6,4.562,5.407,4.086,5z"
      />
      <path
        fill="currentColor"
        d="M16,7c-1.879,0-6,0.757-6,3v9c0,2.245,4.121,3,6,3s6-0.755,6-3v-9C22,7.757,17.879,7,16,7z M20,12.902C19.709,13.303,17.937,14,16,14s-3.709-0.697-4-1.098v-0.682C13.32,12.776,14.985,13,16,13s2.68-0.224,4-0.779V12.902z M20,15.902C19.709,16.303,17.937,17,16,17s-3.709-0.697-4-1.098v-0.682C13.32,15.776,14.985,16,16,16s2.68-0.224,4-0.779V15.902z M16,9c1.784,0,3.438,0.595,3.914,1c-0.476,0.407-2.13,1-3.914,1s-3.438-0.593-3.914-1C12.562,9.595,14.216,9,16,9z M16,20c-1.916,0-3.682-0.684-4-1.086v-0.693C13.32,18.776,14.985,19,16,19s2.68-0.224,4-0.779v0.693C19.682,19.316,17.916,20,16,20z"
      />
    </SvgIcon>
  )
}

export function Chat() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
      />
    </SvgIcon>
  )
}

export function Check() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
      />
    </SvgIcon>
  )
}

export function CheckBold() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  )
}

export function CheckCircle() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      />
    </SvgIcon>
  )
}

export function Clear() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </SvgIcon>
  )
}

export function Edit() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </SvgIcon>
  )
}

export function Email() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Error() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      />
    </SvgIcon>
  )
}

export function Visibility() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      />
    </SvgIcon>
  )
}

export function VisibilityOff() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
      />
    </SvgIcon>
  )
}

export function Face() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
      />
    </SvgIcon>
  )
}

export function Home() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  )
}

export function HorseReacing() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
    >
      <path
        d="M2.67195 2.76722C3.53286 1.888 4.56118 1.19015 5.69623 0.714879C6.83127 0.239608 8.05002 -0.00345563 9.28055 3.7114e-05H9.96805C10.2415 3.7114e-05 10.5039 0.108686 10.6972 0.302083C10.8906 0.49548 10.9993 0.757783 10.9993 1.03129V3.20551L19.447 8.40473C19.5667 8.47895 19.6703 8.57657 19.7515 8.69174C19.8328 8.80692 19.8899 8.93728 19.9196 9.07504C19.9464 9.21487 19.9443 9.35872 19.9132 9.49767C19.8822 9.63663 19.8229 9.76773 19.7391 9.88285L18.5532 11.5243C18.2179 11.9962 17.7559 12.3637 17.2207 12.5842C16.6854 12.8047 16.0986 12.8692 15.5282 12.7703C14.4712 12.5899 12.6063 12.4352 10.8274 13.1141L12.6493 15.6664C13.1696 15.3912 13.6544 15.0535 14.093 14.661C14.297 14.4786 14.5651 14.3848 14.8383 14.4001C15.1114 14.4154 15.3674 14.5386 15.5497 14.7426C15.732 14.9466 15.8259 15.2147 15.8105 15.4878C15.7952 15.761 15.672 16.0169 15.468 16.1993C13.7677 17.7233 11.564 18.565 9.28055 18.5625H9.09148C7.27799 18.5254 5.51511 17.9578 4.02073 16.9297C2.52635 15.9016 1.36597 14.4581 0.683027 12.7777C8.01086e-05 11.0973 -0.175505 9.25365 0.177975 7.47455C0.531452 5.69545 1.3985 4.05892 2.67195 2.76722ZM4.16726 14.3602C4.99326 15.2023 6.01501 15.8268 7.14121 16.1777C8.26742 16.5286 9.46301 16.595 10.6212 16.3711L8.73055 13.7243C7.46637 13.5848 6.29785 12.9846 5.44817 12.0382C4.59849 11.0918 4.12719 9.86563 4.1243 8.59379C4.1243 8.32028 4.23294 8.05798 4.42634 7.86458C4.61974 7.67119 4.88204 7.56254 5.15555 7.56254C5.42905 7.56254 5.69135 7.67119 5.88475 7.86458C6.07815 8.05798 6.1868 8.32028 6.1868 8.59379C6.18625 9.37004 6.47754 10.1181 7.00287 10.6896C7.5282 11.2611 8.24917 11.6143 9.02273 11.6789C11.5665 10.2868 14.3852 10.4844 15.872 10.7336C16.0627 10.767 16.2589 10.746 16.4382 10.6731C16.6176 10.6001 16.7727 10.4781 16.886 10.3211L17.4188 9.58207L9.42664 4.65785C9.27707 4.56559 9.15355 4.43663 9.06782 4.28322C8.98209 4.1298 8.93699 3.95703 8.9368 3.78129V2.07113C7.54084 2.1333 6.19313 2.60023 5.05794 3.41502C3.92274 4.22981 3.04911 5.35725 2.54353 6.65992C2.03795 7.96258 1.92227 9.38419 2.21058 10.7515C2.49889 12.1187 3.17874 13.3726 4.16726 14.3602ZM7.90555 7.21879C7.90555 7.49074 7.98619 7.75658 8.13727 7.9827C8.28836 8.20881 8.50311 8.38505 8.75436 8.48912C9.0056 8.59319 9.28207 8.62042 9.54879 8.56737C9.81552 8.51431 10.0605 8.38336 10.2528 8.19106C10.4451 7.99876 10.5761 7.75376 10.6291 7.48704C10.6822 7.22031 10.655 6.94385 10.5509 6.6926C10.4468 6.44135 10.2706 6.2266 10.0445 6.07552C9.81834 5.92443 9.55249 5.84379 9.28055 5.84379C8.91587 5.84379 8.56614 5.98865 8.30827 6.24652C8.05041 6.50438 7.90555 6.85411 7.90555 7.21879Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Menu() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      />
    </SvgIcon>
  )
}

export function Lock() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      />
    </SvgIcon>
  )
}

export function Loyalty() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function LoyaltyColored() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="6.518%"
          x2="116.948%"
          y1="106.321%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#FFD87A" />
          <stop offset="100%" stopColor="#B532AB" />
        </linearGradient>
      </defs>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="url(#gradient)"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function Phone() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </SvgIcon>
  )
}

export function Remove() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13H5v-2h14v2z" />
    </SvgIcon>
  )
}

export function Room() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </SvgIcon>
  )
}

export function Search() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </SvgIcon>
  )
}

export function Videocam() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      />
    </SvgIcon>
  )
}

export function ViewModule() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
      />
    </SvgIcon>
  )
}

export function ExpandMore() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function KeyboardArrowLeft() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
      />
      <path fill="none" d="M0 0h24v24H0V0z" />
    </SvgIcon>
  )
}

export function Info() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </SvgIcon>
  )
}

export function Warning() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      />
    </SvgIcon>
  )
}

export function ExpandLess() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function PlayArrow() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M8 5v14l11-7z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Sports() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
    >
      <path
        d="M13.8562 9.88439C13.4921 9.83283 13.1687 10.1235 12.8843 10.3063C12.2702 10.6985 11.728 11.1531 11.2046 11.6656C10.8812 11.9828 10.4437 12.4047 10.328 12.861C10.2749 13.0719 10.3405 13.3141 10.3827 13.5203C10.4562 13.8797 10.5687 14.2297 10.6812 14.5781C10.8083 14.9698 10.9553 15.3547 11.1218 15.7313C11.2046 15.9203 11.2952 16.1078 11.3843 16.2953C11.4671 16.4703 11.5218 16.5735 11.7249 16.6C11.953 16.6297 12.1812 16.5953 12.4077 16.586C12.7421 16.5735 13.0765 16.5406 13.4062 16.4844C13.8421 16.411 14.2812 16.3313 14.6983 16.1828C15.0843 16.0438 15.5265 15.8281 15.7499 15.4735C16.2296 14.711 16.5202 13.8453 16.6796 12.9625C16.7265 12.7078 16.7718 12.4485 16.7702 12.1875C16.7718 11.9578 16.7921 11.7219 16.6265 11.5453C16.3296 11.2266 15.978 10.9625 15.614 10.7235C15.0749 10.3735 14.5108 9.97814 13.8562 9.88439V9.88439ZM3.25459 6.20002C2.91553 6.37971 2.6499 6.80783 2.45146 7.12189C2.05459 7.74689 1.73428 8.46877 1.58428 9.19533C1.47021 9.75158 1.71865 10.2938 1.90459 10.8078C2.08584 11.3031 2.40146 11.6953 2.74678 12.0844C2.83428 12.1844 2.94521 12.2594 3.03271 12.3578C3.13271 12.4688 3.25928 12.5735 3.39053 12.6469C3.48428 12.7 3.56865 12.6281 3.66396 12.6063C3.91553 12.5453 4.10303 12.4172 4.33115 12.2969C4.53584 12.1875 4.74678 12.0953 4.95303 11.986C5.39521 11.7485 5.92178 11.5531 6.30771 11.2266C6.35771 11.1844 6.42334 11.1313 6.4374 11.0641C6.47334 10.8969 6.42334 10.6797 6.41553 10.5094C6.40615 10.2703 6.40303 10.0328 6.40146 9.79377C6.3999 9.25314 6.42021 8.71252 6.42021 8.17189C6.4249 7.87033 6.4624 7.57033 6.44834 7.26877C6.42334 6.82033 5.93896 6.66096 5.5749 6.57033C5.06396 6.44377 4.5499 6.27033 4.02803 6.20627C3.8124 6.18283 3.45615 6.09377 3.25459 6.20002V6.20002ZM16.5187 4.85158C16.5671 4.51252 16.3405 4.10471 16.1765 3.80158C15.8515 3.19689 15.3858 2.60314 14.8046 2.13127C14.3608 1.77033 13.7077 1.62346 13.0999 1.56252C12.0108 1.45158 11.1796 1.51877 10.9499 1.55471C10.7187 1.59064 10.5015 1.66096 10.378 1.81408C10.1343 2.11096 10.0921 2.53596 10.0405 2.90158C9.96553 3.42346 9.8999 3.96096 9.96865 4.48596C9.97959 4.57971 9.99365 4.70314 10.039 4.78596C10.1249 4.93908 10.3062 5.01564 10.4858 5.09533C11.4171 5.50627 13.1937 6.52346 13.4827 6.66096C13.914 6.86877 14.3733 6.59221 14.6921 6.36877C15.1343 6.05783 15.6265 5.76564 16.0171 5.41408C16.178 5.27033 16.489 5.05158 16.5187 4.85158V4.85158ZM3.14209 16.475C3.17959 16.5328 3.21553 16.5766 3.27334 16.6203C3.36553 16.6906 3.45303 16.7625 3.54053 16.8391C4.30459 17.5094 5.1999 18.0141 6.0874 18.4985C6.35459 18.6453 6.60928 18.7953 6.88115 18.9313C7.1749 19.0766 7.47803 19.175 7.79365 19.2625C8.00771 19.3219 8.2249 19.3797 8.44678 19.4016C8.65303 19.4219 8.86396 19.4703 9.07178 19.4735C9.19053 19.475 9.2999 19.4703 9.41553 19.4547C9.35928 19.3641 9.30928 19.2485 9.26084 19.1516C9.18428 19 9.10615 18.8469 9.02803 18.6969C8.9374 18.5235 8.86709 18.3422 8.7749 18.1703C8.70303 18.0391 8.60928 17.9031 8.47959 17.8266C8.30615 17.7235 8.14053 17.6219 7.95146 17.5453C7.26084 17.2641 6.64209 16.8672 5.9999 16.4953C5.6749 16.3063 5.35615 16.1047 5.0499 15.8844C4.88584 15.7672 4.72646 15.6453 4.55303 15.5406C4.51709 15.5172 4.48115 15.4891 4.43896 15.4828C4.40146 15.4766 4.34365 15.4781 4.30615 15.4828C4.27178 15.4875 4.23115 15.4938 4.19834 15.5C3.97334 15.5469 3.72959 15.6063 3.49678 15.6578C3.2749 15.7078 3.02646 15.725 2.81396 15.8063C2.73115 15.8375 2.74053 15.8844 2.77334 15.9563C2.82334 16.0688 2.89678 16.1719 2.97334 16.2656C3.0249 16.3328 3.08896 16.3953 3.14209 16.475V16.475Z"
        fill="#8942A7"
      />
      <path
        d="M5.84532 7.55002C5.79241 7.55006 5.74057 7.53513 5.69578 7.50695C5.651 7.47878 5.61509 7.43852 5.59222 7.39081C5.56934 7.3431 5.56043 7.28989 5.56651 7.23733C5.57259 7.18477 5.59341 7.135 5.62657 7.09377C5.70314 7.00002 7.50626 4.79064 10.7313 4.29064C10.7676 4.2851 10.8046 4.28677 10.8403 4.29555C10.876 4.30433 10.9096 4.32005 10.9392 4.34182C10.9688 4.36358 10.9938 4.39096 11.0128 4.4224C11.0318 4.45383 11.0445 4.4887 11.05 4.52502C11.0556 4.56134 11.0539 4.59839 11.0451 4.63407C11.0363 4.66974 11.0206 4.70334 10.9988 4.73294C10.9771 4.76253 10.9497 4.78756 10.9183 4.80657C10.8868 4.82559 10.852 4.83823 10.8156 4.84377C7.81407 5.31096 6.0797 7.42502 6.06251 7.44533C6.00626 7.51408 5.92657 7.55002 5.84532 7.55002ZM5.1797 17.3594C5.09845 17.3594 5.0172 17.325 4.96251 17.2563C4.88595 17.1625 3.10939 14.9313 3.30157 11.675C3.31095 11.5203 3.4422 11.4016 3.59689 11.411C3.75157 11.4203 3.86876 11.5531 3.85939 11.7078C3.68126 14.75 5.3797 16.8828 5.39689 16.9031C5.49532 17.0235 5.47501 17.2 5.35626 17.2969C5.3047 17.3375 5.2422 17.3594 5.1797 17.3594V17.3594ZM7.2922 18.4594C7.14845 18.4594 7.02657 18.35 7.01407 18.2031C7.00157 18.0485 7.11564 17.9125 7.27032 17.9C7.29689 17.8985 10.0188 17.6422 12.0844 15.4141C12.1352 15.3597 12.2055 15.3277 12.2799 15.325C12.3543 15.3224 12.4267 15.3494 12.4813 15.4C12.5953 15.5047 12.6016 15.6828 12.4953 15.7969C10.2766 18.1875 7.43595 18.4485 7.3172 18.4594C7.30782 18.4578 7.30001 18.4594 7.2922 18.4594V18.4594ZM3.40001 7.21408C3.26876 7.21408 3.15157 7.12189 3.12657 6.98752C3.11095 6.90939 2.75782 5.05783 3.51876 2.86408C3.57032 2.71721 3.72814 2.63908 3.87501 2.69064C4.02032 2.74221 4.09845 2.90002 4.04845 3.04689C3.33595 5.10002 3.67189 6.86096 3.67657 6.87971C3.70626 7.03127 3.60782 7.17971 3.4547 7.20939C3.43751 7.21252 3.41876 7.21408 3.40001 7.21408V7.21408ZM11.5422 2.61877C11.4844 2.61877 11.425 2.60002 11.3766 2.56252C11.3625 2.55314 9.9047 1.49533 7.75314 1.2594C7.60001 1.24377 7.48751 1.10471 7.5047 0.951583C7.52032 0.796895 7.65939 0.68752 7.81251 0.703145C10.1219 0.954708 11.6438 2.06408 11.7078 2.11096C11.8313 2.20314 11.8578 2.37814 11.7656 2.50314C11.7125 2.57971 11.6281 2.61877 11.5422 2.61877ZM18.6141 7.17658C18.5328 7.17658 18.4516 7.14064 18.3953 7.07189C17.0297 5.38283 15.3578 4.73439 15.3422 4.72814C15.2727 4.70188 15.2164 4.64916 15.1857 4.58153C15.155 4.51389 15.1522 4.43684 15.1781 4.36721C15.2328 4.22189 15.3953 4.15002 15.5391 4.20314C15.6141 4.23127 17.3703 4.91252 18.8297 6.71877C18.9281 6.83908 18.9078 7.01564 18.7875 7.11252C18.7375 7.15627 18.675 7.17658 18.6141 7.17658V7.17658ZM13.6688 10.9641C13.6578 10.9641 13.6438 10.9625 13.6328 10.961C13.5963 10.9563 13.5612 10.9444 13.5293 10.926C13.4974 10.9077 13.4695 10.8832 13.4471 10.854C13.4248 10.8248 13.4084 10.7915 13.399 10.7559C13.3895 10.7204 13.3872 10.6833 13.3922 10.6469C13.75 7.96877 13.3984 5.99064 13.3938 5.97033C13.3656 5.81877 13.4656 5.67189 13.6188 5.64533C13.7719 5.61564 13.9172 5.71877 13.9453 5.87033C13.9594 5.95471 14.3172 7.95627 13.9469 10.7219C13.9281 10.8625 13.8078 10.9641 13.6688 10.9641ZM11.2375 13.2516C11.2281 13.2516 11.2219 13.2516 11.2125 13.25C7.73126 12.9422 5.44064 10.9781 5.34376 10.8953C5.28785 10.8465 5.25351 10.7775 5.24824 10.7035C5.24297 10.6294 5.2672 10.5563 5.31564 10.5C5.4172 10.3828 5.59376 10.3703 5.71095 10.4719C5.73439 10.4906 7.96876 12.4016 11.2625 12.6922C11.3341 12.699 11.4004 12.733 11.4476 12.7873C11.4948 12.8416 11.5194 12.9119 11.5161 12.9838C11.5129 13.0557 11.4822 13.1235 11.4303 13.1734C11.3785 13.2232 11.3094 13.2512 11.2375 13.2516V13.2516ZM1.23907 10.0406C1.00314 10.0406 0.745323 10.011 0.504698 9.91877C0.435204 9.8925 0.378936 9.83979 0.348194 9.77215C0.317451 9.70452 0.314733 9.62746 0.340636 9.55783C0.396886 9.41408 0.556261 9.34064 0.703136 9.39377C1.21876 9.59064 1.90782 9.38908 1.91564 9.38752C2.06251 9.34377 2.21876 9.42658 2.26251 9.57658C2.30782 9.72346 2.22345 9.87971 2.07657 9.92502C2.05314 9.93127 1.68439 10.0406 1.23907 10.0406V10.0406ZM16.5109 12.4313C16.4047 12.4313 16.3047 12.3703 16.2578 12.2688C16.1922 12.1297 16.2547 11.9625 16.3938 11.8969C16.4094 11.8891 18.0375 11.1188 19.2766 9.34377C19.3641 9.21564 19.5391 9.18439 19.6656 9.27346C19.7922 9.36252 19.8234 9.53596 19.7359 9.66252C18.4078 11.5672 16.7016 12.3703 16.6297 12.4047C16.5891 12.4219 16.55 12.4313 16.5109 12.4313ZM16.5109 17.161C16.4484 17.161 16.3859 17.1406 16.3328 17.1C15.6922 16.5953 15.0719 15.6781 15.0453 15.6406C14.9578 15.5094 14.9922 15.3313 15.1234 15.2422C15.2531 15.1547 15.4328 15.1891 15.5203 15.3219C15.5266 15.3297 16.1172 16.2016 16.6875 16.65C16.8109 16.7485 16.8328 16.9281 16.7359 17.0531C16.6781 17.1219 16.5953 17.161 16.5109 17.161V17.161Z"
        fill="#8942A7"
      />
      <path
        d="M9.99995 19.9564C4.50933 19.9564 0.0437012 15.4908 0.0437012 10.0002C0.0437012 4.51113 4.50933 0.0439453 9.99995 0.0439453C15.4906 0.0439453 19.9562 4.51113 19.9562 9.99863C19.9562 15.4908 15.489 19.9564 9.99995 19.9564ZM9.99995 1.16426C5.12808 1.16426 1.16401 5.12832 1.16401 10.0002C1.16401 14.8721 5.12651 18.8361 9.99839 18.8361C14.8703 18.8361 18.8343 14.8721 18.8343 10.0002C18.8359 5.12832 14.8703 1.16426 9.99995 1.16426Z"
        fill="#8942A7"
      />
    </SvgIcon>
  )
}

export function Spinner() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g fill="none" fillRule="evenodd" strokeWidth="2">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </SvgIcon>
  )
}

export function Roulette() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      width="1em"
      height="1em"
    >
      <g fill="none" fillRule="nonzero">
        <path
          fill="currentColor"
          d="M12.355 1.799a7.482 7.482 0 0 0-10.556.82 7.487 7.487 0 1 0 10.556-.82zm1.451 7.86l-2.288-.79c.308-.898.304-1.873 0-2.763l2.286-.787c.181.528.296 1.083.34 1.654a6.66 6.66 0 0 1-.338 2.686zm.129-4.403v-.001.001zm-1.413-2.151L10.7 4.687a4.24 4.24 0 0 0-2.393-1.382l.46-2.36a6.648 6.648 0 0 1 3.755 2.16zM5.215 1.21A6.59 6.59 0 0 1 6.21.94l.46 2.366a4.242 4.242 0 0 0-2.394 1.38L2.452 3.1a6.662 6.662 0 0 1 2.763-1.889zM1.168 5.315l2.288.789a4.276 4.276 0 0 0-.001 2.763l-2.288.788a6.718 6.718 0 0 1 0-4.34zm1.28 6.557l1.825-1.586a4.24 4.24 0 0 0 2.393 1.382l-.461 2.374a6.664 6.664 0 0 1-3.757-2.17zm7.31 1.897a6.678 6.678 0 0 1-.993.273l-.46-2.373a4.242 4.242 0 0 0 2.393-1.381l1.824 1.586a6.675 6.675 0 0 1-2.764 1.895z"
        />
        <g fill="currentColor" transform="translate(1 2)">
          <circle cx="3.716" cy=".702" r="1" />
          <circle cx=".957" cy="5.494" r="1" />
          <circle cx="3.728" cy="10.279" r="1" />
          <circle cx="9.258" cy="10.272" r="1" />
          <circle cx="12.016" cy="5.479" r="1" />
          <circle cx="9.245" cy=".694" r="1" />
        </g>
      </g>
    </svg>
  )
}

export function Done() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Create() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Language() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Refresh() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Notifications() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Person() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function AllInclusive() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Article() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Favorite() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Casino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M19.592 6.8H22.8A1.2 1.2 0 0124 8v12a1.2 1.2 0 01-1.2 1.2H1.2A1.2 1.2 0 010 20V8a1.2 1.2 0 011.2-1.2h3.208A8.4 8.4 0 0112 2a8.4 8.4 0 017.592 4.8zM2.4 9.2h4.8v9.6H2.4zm12 9.6V9.2H9.6v9.6zm2.4-9.6h4.8v9.6h-4.8z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function LiveCasino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M20.485 20.485c-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97zm-16.07-2.598l1.716-1.715A7.16 7.16 0 014.9 13.2H2.474a9.553 9.553 0 001.94 4.687h.001zM2.476 10.8H4.9a7.162 7.162 0 011.23-2.972L4.417 6.113A9.553 9.553 0 002.475 10.8h.001zm3.638-6.384L7.828 6.13A7.161 7.161 0 0110.8 4.9V2.474a9.553 9.553 0 00-4.687 1.94l.001.002zm10.06 1.715A7.161 7.161 0 0013.2 4.9V2.474a9.553 9.553 0 014.687 1.94L16.172 6.13l.002.001zM13.2 21.525a9.552 9.552 0 004.687-1.94l-1.715-1.716A7.16 7.16 0 0113.2 19.1v2.426-.001zm-2.4 0V19.1a7.162 7.162 0 01-2.972-1.23l-1.715 1.714a9.554 9.554 0 004.687 1.941zm8.784-15.412a9.554 9.554 0 011.941 4.687H19.1a7.162 7.162 0 00-1.23-2.972l1.714-1.715zM19.1 13.2h2.425a9.552 9.552 0 01-1.94 4.687l-1.716-1.715A7.161 7.161 0 0019.1 13.2zm-3.706 2.194a4.8 4.8 0 11-6.788-6.788 4.8 4.8 0 016.788 6.788z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Faq() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Wallet() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 64 64"
    >
      <g fill="currentColor">
        <path
          d="M10.1825 32.2013V25.455C10.1825 23.1674 11.9569 21.307 14.1987 21.1266L20.4639 10.1836C21.0445 9.17151 21.982 8.44815 23.1038 8.14778C24.2203 7.84945 25.3878 8.00613 26.3871 8.58775L47.8643 21.0914H51.6364C54.0429 21.0914 56 23.0484 56 25.455V51.6364C56 54.0429 54.043 56 51.6364 56H14.5461C12.1395 56 10.1825 54.043 10.1825 51.6364V44.8901C8.91542 44.4383 8.00071 43.2387 8.00071 41.8184V35.273C8.00071 33.8527 8.91542 32.6532 10.1825 32.2013ZM16.7339 21.0914H26.2422L19.1109 16.9396L16.7339 21.0914ZM20.1949 15.0463L30.5784 21.0914H34.8853L21.2718 13.1654L20.1949 15.0463ZM25.2888 10.4733C24.7956 10.1846 24.2193 10.1079 23.6684 10.255C23.1113 10.4041 22.6467 10.7642 22.358 11.2681L22.3558 11.2721L39.2213 21.0914H43.528L25.2888 10.4733ZM12.3643 51.6364C12.3643 52.8391 13.3433 53.8181 14.5461 53.8181H51.6364C52.8391 53.8181 53.8181 52.8391 53.8181 51.6364V25.455C53.8181 24.2523 52.8391 23.2733 51.6364 23.2733H14.5461C13.3433 23.2733 12.3643 24.2523 12.3643 25.455V32.0004H18.9097C22.519 32.0004 25.455 34.9364 25.455 38.5457C25.455 42.1551 22.519 45.0911 18.9097 45.0911H12.3643V51.6364ZM10.1825 41.8184C10.1825 42.4202 10.6714 42.9093 11.2734 42.9093H18.9097C21.3162 42.9093 23.2733 40.9523 23.2733 38.5457C23.2733 36.1392 21.3163 34.1821 18.9097 34.1821H11.2734C10.6715 34.1821 10.1825 34.6711 10.1825 35.273V41.8184Z"
          fill="currentColor"
        />
        <path
          d="M18.91 36.3633C20.1128 36.3633 21.0918 37.3423 21.0918 38.545C21.0918 39.7477 20.1128 40.7268 18.91 40.7268C17.7073 40.7268 16.7283 39.7477 16.7283 38.545C16.7282 37.3423 17.7072 36.3633 18.91 36.3633Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

export function Ball() {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0741 1.79212C11.7226 0.689534 10.0471 0.06006 8.30395 0C8.47338 0.999939 8.4299 2.02437 8.17635 3.00636C7.9228 3.98835 7.4649 4.90578 6.83256 5.69871L8.00005 6.86619L13.0741 1.79212ZM4.55292 5.68668L1.79217 2.92593C0.905649 4.01233 0.321487 5.31342 0.0986764 6.69781C0.870537 6.85055 1.66588 6.83948 2.43318 6.6653C3.20049 6.49112 3.92266 6.15771 4.55292 5.68668ZM14.2079 2.92593L9.13386 8L10.3013 9.16749C11.0943 8.53528 12.0118 8.07746 12.9937 7.82392C13.9757 7.57038 15.0001 7.52683 16 7.6961C15.94 5.95293 15.3105 4.27743 14.2079 2.92593ZM15.9014 9.3022C15.1296 9.14945 14.3342 9.16052 13.5669 9.3347C12.7996 9.50888 12.0774 9.84229 11.4472 10.3133L14.2079 13.0741C15.0949 11.988 15.6791 10.6867 15.9014 9.3022ZM5.68673 4.55287C6.15776 3.92261 6.49117 3.20044 6.66535 2.43313C6.83953 1.66583 6.8506 0.870488 6.69786 0.0986268C5.31335 0.32107 4.01218 0.905273 2.92598 1.79212L5.68673 4.55287ZM9.30225 15.9014C10.6866 15.6789 11.9877 15.095 13.0741 14.2087L10.3134 11.4479C9.84227 12.078 9.50882 12.8 9.33463 13.5672C9.16045 14.3344 9.14941 15.1296 9.30225 15.9014ZM8.00005 9.13381L2.92598 14.2079C4.27748 15.3105 5.95298 15.9399 7.69615 16C7.52673 15.0001 7.57021 13.9756 7.82375 12.9936C8.0773 12.0117 8.5352 11.0942 9.16754 10.3013L8.00005 9.13381ZM1.79217 13.0741L6.86624 8L5.69876 6.83252C4.90576 7.46472 3.98832 7.92254 3.00635 8.17608C2.02439 8.42962 0.99999 8.47317 4.95911e-05 8.3039C0.0601096 10.0471 0.689584 11.7226 1.79217 13.0741Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Moments() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 20"
    >
      <path
        d="M18.9202 2.67794C18.1383 1.91273 17.2566 1.5433 16.3337 1.5896C16.2736 1.59217 16.2113 1.59677 16.1452 1.6043V0.526972C16.1452 0.236368 15.902 0 15.6031 0L4.39737 0.00018381C4.09853 0.00018381 3.85527 0.236562 3.85527 0.527156V1.60411C3.79002 1.59694 3.72844 1.59216 3.66763 1.58959C2.72803 1.54529 1.8599 1.91475 1.08018 2.67793C0.0309681 3.70449 -0.27658 5.24372 0.257416 6.79452C0.912247 8.69748 2.57715 10.1935 4.71708 10.8056C5.50975 12.1079 6.80108 13.0878 8.27986 13.5107V15.0475H6.603C6.45937 15.0475 6.3196 15.1045 6.21824 15.2032L4.87285 16.5202C4.84235 16.55 4.81493 16.5853 4.78521 16.6356C4.78405 16.6373 4.77227 16.6599 4.77131 16.6614C4.74833 16.7077 4.73366 16.7481 4.72459 16.7963C4.7188 16.8274 4.71494 16.8593 4.71494 16.8919V18.473C4.71494 18.7636 4.95818 19 5.25704 19H14.7424C15.0413 19 15.2845 18.7636 15.2845 18.473L15.2832 16.963C15.2869 16.9395 15.2898 16.9163 15.2898 16.8919C15.2898 16.7259 15.212 16.573 15.0905 16.4848L13.7809 15.2031C13.6799 15.1042 13.5398 15.0474 13.3961 15.0474H11.7193L11.7194 13.5107C13.1982 13.0882 14.4896 12.1081 15.2824 10.8056C17.4218 10.1937 19.0867 8.69787 19.7423 6.79453C20.2766 5.24373 19.9693 3.70488 18.9201 2.67795L18.9202 2.67794ZM18.2045 6.29202C17.8682 7.26861 17.0748 8.17734 16.0541 8.76793C16.1147 8.4266 16.1453 8.08233 16.1453 7.74081V3.20308C16.2346 3.18378 16.3203 3.17275 16.4051 3.16907L16.4671 3.16779C16.914 3.16779 17.34 3.37218 17.77 3.7931C18.3852 4.39546 18.5437 5.30621 18.2045 6.29197L18.2045 6.29202ZM2.23063 3.79348C2.66132 3.37219 3.08294 3.16741 3.52003 3.16741C3.54281 3.16741 3.56578 3.16796 3.58972 3.16925C3.67582 3.17274 3.76327 3.18395 3.85536 3.20344V7.74117C3.85536 8.08324 3.88586 8.42733 3.94667 8.7681C2.92603 8.17789 2.13217 7.26897 1.79626 6.29219C1.45707 5.30681 1.61537 4.39601 2.23063 3.79346V3.79348Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Mahjong() {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20H20V0H0V20ZM2.188 5.29714C2.37594 5.1106 2.67818 4.99995 3.00006 4.99995H9.00006V2.85709C9.00006 2.46265 9.44783 2.14281 10.0001 2.14281C10.5523 2.14281 11.0001 2.46265 11.0001 2.85709V4.99995H17.0001C17.3215 5.00027 17.6228 5.1106 17.8108 5.29682C17.9983 5.48304 18.0496 5.7222 17.9483 5.94L15.9483 10.2257C15.8121 10.5172 15.4304 10.7139 15.0001 10.7142H11.0001V17.1428C11.0001 17.5373 10.5523 17.8571 10.0001 17.8571C9.44783 17.8571 9.00006 17.5373 9.00006 17.1428V10.7142H5.00006C4.5697 10.7139 4.188 10.5172 4.05184 10.2257L2.05184 5.94C1.9505 5.72252 2.00095 5.48336 2.188 5.29714Z"
        fill="#8842A7"
      />
      <path
        d="M8.99994 9.28571V6.42857H4.38794L5.72097 9.28571H8.99994Z"
        fill="#8842A7"
      />
      <path
        d="M15.6125 6.42857H11.0005V9.28571H14.2795L15.6125 6.42857Z"
        fill="#8842A7"
      />
    </SvgIcon>
  )
}

export function Star() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function ExitFullscreen() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
      width="28"
      height="28"
    >
      <path
        d="M21.5 11.375h-4.375V7M23.25 5.25l-6.125 6.125M7.5 16.625h4.375V21M5.75 22.75l6.125-6.125M17.125 21v-4.375H21.5M23.25 22.75l-6.125-6.125M11.875 7v4.375H7.5M5.75 5.25l6.125 6.125"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
export function Fullscreen() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
      width="28"
      height="28"
    >
      <path
        d="M18.875 5.25h4.375v4.375M17.125 11.375 23.25 5.25M10.125 22.75H5.75v-4.375M11.875 16.625 5.75 22.75M23.25 18.375v4.375h-4.375M17.125 16.625l6.125 6.125M5.75 9.625V5.25h4.375M11.875 11.375 5.75 5.25"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function GamesMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 16 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.27665 1.46626L8.27664 1.46626L4.26827 5.47494L4.26827 5.47495C3.41542 6.32787 2.98899 6.75433 2.76104 7.21436C2.32734 8.08965 2.32736 9.11727 2.7611 9.99254C2.78322 10.0372 2.80721 10.0815 2.83327 10.1259C3.16666 10.6941 3.33336 10.9782 3.71425 11.027C4.09514 11.0758 4.38547 10.7855 4.96613 10.2048L5.418 9.75296C5.64708 9.52388 6.01849 9.52388 6.24757 9.75296C6.47666 9.98205 6.47666 10.3535 6.24757 10.5825L5.79572 11.0344C5.21504 11.6151 4.9247 11.9054 4.97351 12.2863C5.02232 12.6672 5.30644 12.8339 5.87466 13.1672C5.91903 13.1932 5.96329 13.2172 6.00787 13.2393C6.88319 13.673 7.91088 13.673 8.78618 13.2392C9.24622 13.0112 9.67268 12.5848 10.5256 11.7318L10.5256 11.7318L14.5339 7.72318C15.0749 7.1821 15.3454 6.91156 15.5389 6.59585C15.7104 6.31594 15.8368 6.01078 15.9134 5.69157C15.9999 5.33153 15.9999 4.94895 15.9999 4.18378L15.9999 3.75425C15.9999 2.44014 15.9999 1.78308 15.7441 1.28116C15.5192 0.839654 15.1602 0.4807 14.7187 0.255742C14.2168 0 13.5597 0 12.2456 0H11.8163C11.0511 0 10.6684 0 10.3084 0.0864506C9.98913 0.163097 9.68394 0.289516 9.40402 0.461066C9.08829 0.654558 8.81774 0.925125 8.27665 1.46626ZM13 5.0205C13 6.13519 12.0964 7.03882 10.9817 7.03882C9.86699 7.03882 8.96337 6.13519 8.96337 5.02051C8.96336 3.90582 9.86699 3.00219 10.9817 3.00219C12.0964 3.00219 13 3.90582 13 5.0205ZM3.06332 5.1164C2.797 5.38275 2.66385 5.51592 2.50739 5.57548C2.36948 5.62798 2.21953 5.64039 2.07486 5.61128C1.91074 5.57826 1.75749 5.4688 1.45101 5.24987L1.451 5.24987L0.77829 4.76934C0.364726 4.47392 0.157943 4.32622 0.0711187 4.13677C-0.00507323 3.97053 -0.0206035 3.78284 0.0272272 3.60633C0.0817327 3.4052 0.261424 3.22551 0.620808 2.86614L0.892954 2.594C1.41239 2.07457 1.67211 1.81486 1.97946 1.65071C2.25155 1.50539 2.54962 1.41515 2.85662 1.38514C3.2034 1.35125 3.56356 1.42328 4.28388 1.56736L5.07764 1.72612C5.45003 1.8006 5.63622 1.83784 5.72334 1.93602C5.79923 2.02155 5.83388 2.136 5.81819 2.24926C5.80017 2.37927 5.66591 2.51355 5.39739 2.78209L3.06332 5.1164ZM13.4071 15.1083C13.9267 14.5888 14.1864 14.3291 14.3506 14.0217C14.4959 13.7495 14.5862 13.4514 14.6161 13.1443C14.65 12.7975 14.5779 12.4373 14.4337 11.7169L14.2748 10.923C14.2003 10.5506 14.163 10.3645 14.0648 10.2774C13.9793 10.2015 13.8648 10.1668 13.7516 10.1825C13.6216 10.2006 13.4873 10.3349 13.2188 10.6034L10.8848 12.9377L10.8848 12.9378C10.6185 13.2041 10.4854 13.3372 10.4259 13.4937C10.3734 13.6316 10.361 13.7815 10.3901 13.9262C10.4231 14.0903 10.5325 14.2435 10.7514 14.5499L11.232 15.2227C11.5274 15.6363 11.6751 15.8431 11.8646 15.9299C12.0308 16.0061 12.2185 16.0217 12.395 15.9738C12.5962 15.9193 12.7758 15.7396 13.1352 15.3803L13.4071 15.1083Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

GamesMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function LiveCasinoMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 19 17"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5367 7.62549L14.5173 2.00131C14.5135 0.896745 13.615 0.00439619 12.5105 0.00819077L11.3904 0.0120387L14.5367 7.62549ZM1.95784 3.08511C0.939257 3.51237 0.459897 4.68447 0.887164 5.70305L4.6972 14.786C5.12446 15.8046 6.29656 16.2839 7.31515 15.8567L12.6417 13.6223C13.6603 13.1951 14.1397 12.023 13.7124 11.0044L9.90239 1.92143C9.47513 0.902843 8.30303 0.423484 7.28445 0.850751L1.95784 3.08511ZM6.50666 5.38754C6.20932 5.19034 5.80705 5.35908 5.73938 5.70939L5.10915 8.97184C5.07087 9.17003 5.1555 9.3718 5.32372 9.48336L8.09282 11.3199C8.39016 11.5171 8.79243 11.3484 8.8601 10.998L9.49032 7.73559C9.52861 7.53741 9.44397 7.33564 9.27575 7.22407L6.50666 5.38754ZM18.5907 4.46568L16.3731 9.63459L16.5117 1.39748L17.5412 1.83915C18.5563 2.27465 19.0262 3.45059 18.5907 4.46568Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

LiveCasinoMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function PromotionsMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 16 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6028 2.56291C11.6028 1.97588 11.1269 1.5 10.5399 1.5H10.4817C9.98664 1.5 9.55018 1.82474 9.40792 2.29895L9.1226 3.25H11.3509C11.508 3.06472 11.6028 2.82488 11.6028 2.56291ZM13.0097 3.25C13.0704 3.03133 13.1028 2.80091 13.1028 2.56291C13.1028 1.14745 11.9554 0 10.5399 0H10.4817C9.35773 0 8.36297 0.715931 8.00177 1.77254C7.64058 0.715931 6.64581 0 5.52182 0H5.46364C4.04819 0 2.90073 1.14745 2.90073 2.56291C2.90073 2.80091 2.93317 3.03133 2.99387 3.25H2.00011C1.03362 3.25 0.250114 4.0335 0.250114 5C0.250114 5.9665 1.03362 6.75 2.00011 6.75H14.0001C14.9666 6.75 15.7501 5.9665 15.7501 5C15.7501 4.0335 14.9666 3.25 14.0001 3.25H13.0097ZM4.65263 3.25C4.4955 3.06472 4.40073 2.82488 4.40073 2.56291C4.40073 1.97588 4.87661 1.5 5.46364 1.5H5.52182C6.01691 1.5 6.45337 1.82474 6.59563 2.29895L6.88095 3.25H4.65263ZM3.62063 8.24988L3.7144 8.25H12.2858L12.3796 8.24988C12.7617 8.24914 13.127 8.24844 13.4442 8.35943C14.0043 8.55543 14.4447 8.99582 14.6407 9.55596C14.7517 9.87314 14.751 10.2384 14.7502 10.6205L14.7501 10.7143L14.7502 10.8633C14.7506 11.9156 14.7509 12.6349 14.5397 13.2385C14.1628 14.3157 13.3158 15.1626 12.2387 15.5396C11.635 15.7508 10.9157 15.7505 9.86336 15.75L9.7144 15.75H6.28583L6.13687 15.75C5.08451 15.7505 4.36522 15.7508 3.76157 15.5396C2.68439 15.1626 1.83747 14.3157 1.46055 13.2385C1.24933 12.6349 1.24963 11.9156 1.25007 10.8632L1.25011 10.7143L1.24999 10.6205C1.24926 10.2384 1.24855 9.87314 1.35954 9.55596C1.55554 8.99582 1.99594 8.55543 2.55607 8.35943C2.87326 8.24844 3.23852 8.24914 3.62063 8.24988Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

PromotionsMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function SupportMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 17 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00061 0C3.58202 0 4.95911e-05 3.58197 4.95911e-05 8.00056C4.95911e-05 9.19858 0.2641 10.337 0.737587 11.3591L1.41782 11.044L0.737587 11.3591C1.10178 12.1453 1.26605 12.5043 1.1201 13.0122L1.83787 13.2184L1.1201 13.0122C1.09199 13.11 1.05 13.201 0.983046 13.3462C0.961843 13.3922 0.938136 13.4436 0.911574 13.5023C0.819326 13.7064 0.689752 14.0088 0.661399 14.3541C0.582744 15.3117 1.4261 16.0877 2.37392 15.9298L2.25357 15.2074L2.37392 15.9298C2.87136 15.8469 3.30558 15.622 3.59368 15.4727C3.66002 15.4384 3.7186 15.408 3.76843 15.3843C4.05304 15.2491 4.26106 15.1905 4.58466 15.2666L4.58467 15.2666C4.58519 15.2667 4.60425 15.2716 4.65453 15.2877C4.70197 15.303 4.76508 15.3242 4.84803 15.353C5.01415 15.4107 5.24321 15.4926 5.55563 15.6043L5.79043 14.948L5.55563 15.6043C6.30463 15.8723 7.09985 16.0011 8.00061 16.0011C12.4192 16.0011 16.0012 12.4191 16.0012 8.00056C16.0012 3.58197 12.4192 0 8.00061 0ZM8.00005 5C7.44776 5 7.00005 5.44772 7.00005 6V6.5C7.00005 7.05228 6.55233 7.5 6.00005 7.5C5.44776 7.5 5.00005 7.05228 5.00005 6.5V6C5.00005 4.34315 6.3432 3 8.00005 3C9.6569 3 11 4.34315 11 6V6.12132C11 6.94915 10.6712 7.74307 10.0858 8.32843L8.70716 9.70711C8.31663 10.0976 7.68347 10.0976 7.29294 9.70711C6.90242 9.31658 6.90242 8.68342 7.29294 8.29289L8.67162 6.91421C8.88191 6.70393 9.00005 6.41871 9.00005 6.12132V6C9.00005 5.44772 8.55233 5 8.00005 5ZM8.00005 13C8.55233 13 9.00005 12.5523 9.00005 12C9.00005 11.4477 8.55233 11 8.00005 11C7.44776 11 7.00005 11.4477 7.00005 12C7.00005 12.5523 7.44776 13 8.00005 13Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

SupportMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function ExpirationTimeIcon() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.416504 5.99972C0.416504 2.91592 2.91641 0.416016 6.00021 0.416016C9.08401 0.416016 11.5839 2.91592 11.5839 5.99972C11.5839 9.08352 9.08401 11.5834 6.00021 11.5834C2.91641 11.5834 0.416504 9.08352 0.416504 5.99972ZM6.5 2.99805C6.5 2.7219 6.27614 2.49805 6 2.49805C5.72386 2.49805 5.5 2.7219 5.5 2.99805V6.16471C5.5 6.32399 5.57588 6.47373 5.70432 6.56792L8.20432 8.40125C8.427 8.56455 8.7399 8.51641 8.9032 8.29373C9.0665 8.07105 9.01836 7.75815 8.79568 7.59484L6.5 5.91134V2.99805Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function EmptyOffersDrawer() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="117"
      viewBox="0 0 108 117"
    >
      <path
        d="M34.5 59H58.5V83H34.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 94H47.2868L58.5 83H34.7132L23.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70.2132V94L34.5 82.7868V59L23.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 94V70.2132L58.5 59V82.7868L47.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 70H23.5L34.7132 59H58.5L47.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70H47.5V94H23.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 105H36.2868L47.5 94H23.7132L12.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81.2132V105L23.5 93.7868V70L12.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 105V81.2132L47.5 70V93.7868L36.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 81H12.5L23.7132 70H47.5L36.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81H36.5V105H12.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 116H25.2868L36.5 105H12.7132L1.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 92.2132V116L12.5 104.787V81L1.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 116V92.2132L36.5 81V104.787L25.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 92H1.5L12.7132 81H36.5L25.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 59H82.5V83H58.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 94H71.2868L82.5 83H58.7132L47.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70.2132V94L58.5 82.7868V59L47.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 94V70.2132L82.5 59V82.7868L71.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 70H47.5L58.7132 59H82.5L71.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70H71.5V94H47.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 105H60.2868L71.5 94H47.7132L36.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81.2132V105L47.5 93.7868V70L36.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 105V81.2132L71.5 70V93.7868L60.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 81H36.5L47.7132 70H71.5L60.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81H60.5V105H36.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 116H49.2868L60.5 105H36.7132L25.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92.2132V116L36.5 104.787V81L25.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 116V92.2132L60.5 81V104.787L49.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 92H25.5L36.7132 81H60.5L49.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 59H106.5V83H82.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 94H95.2868L106.5 83H82.7132L71.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70.2132V94L82.5 82.7868V59L71.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 94V70.2132L106.5 59V82.7868L95.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 70H71.5L82.7132 59H106.5L95.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70H95.5V94H71.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 105H84.2868L95.5 94H71.7132L60.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81.2132V105L71.5 93.7868V70L60.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 105V81.2132L95.5 70V93.7868L84.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 81H60.5L71.7132 70H95.5L84.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81H84.5V105H60.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 116H73.2868L84.5 105H60.7132L49.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92.2132V116L60.5 104.787V81L49.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 116V92.2132L84.5 81V104.787L73.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 92H49.5L60.7132 81H84.5L73.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 35H58.5V59H34.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70H47.2868L58.5 59H34.7132L23.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46.2132V70L34.5 58.7868V35L23.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70V46.2132L58.5 35V58.7868L47.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 46H23.5L34.7132 35H58.5L47.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46H47.5V70H23.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81H36.2868L47.5 70H23.7132L12.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57.2132V81L23.5 69.7868V46L12.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81V57.2132L47.5 46V69.7868L36.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 57H12.5L23.7132 46H47.5L36.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57H36.5V81H12.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 92H25.2868L36.5 81H12.7132L1.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 68.2132V92L12.5 80.7868V57L1.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92V68.2132L36.5 57V80.7868L25.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 68H1.5L12.7132 57H36.5L25.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 35H82.5V59H58.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70H71.2868L82.5 59H58.7132L47.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46.2132V70L58.5 58.7868V35L47.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70V46.2132L82.5 35V58.7868L71.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 46H47.5L58.7132 35H82.5L71.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46H71.5V70H47.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81H60.2868L71.5 70H47.7132L36.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57.2132V81L47.5 69.7868V46L36.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81V57.2132L71.5 46V69.7868L60.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 57H36.5L47.7132 46H71.5L60.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57H60.5V81H36.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92H49.2868L60.5 81H36.7132L25.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 68.2132V92L36.5 80.7868V57L25.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92V68.2132L60.5 57V80.7868L49.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 68H25.5L36.7132 57H60.5L49.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 35H106.5V59H82.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70H95.2868L106.5 59H82.7132L71.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46.2132V70L82.5 58.7868V35L71.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 70V46.2132L106.5 35V58.7868L95.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 46H71.5L82.7132 35H106.5L95.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46H95.5V70H71.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81H84.2868L95.5 70H71.7132L60.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57.2132V81L71.5 69.7868V46L60.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 81V57.2132L95.5 46V69.7868L84.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 57H60.5L71.7132 46H95.5L84.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57H84.5V81H60.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92H73.2868L84.5 81H60.7132L49.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68.2132V92L60.5 80.7868V57L49.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 92V68.2132L84.5 57V80.7868L73.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 68H49.5L60.7132 57H84.5L73.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 11H58.5V35H34.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46H47.2868L58.5 35H34.7132L23.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 22.2132V46L34.5 34.7868V11L23.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46V22.2132L58.5 11V34.7868L47.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 22H23.5L34.7132 11H58.5L47.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 22H47.5V46H23.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57H36.2868L47.5 46H23.7132L12.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 33.2132V57L23.5 45.7868V22L12.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57V33.2132L47.5 22V45.7868L36.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 33H12.5L23.7132 22H47.5L36.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="33"
        width="24"
        height="24"
        fill="#A1E5E5"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 1H36.5V25H12.5V1Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 36H25.2868L36.5 25H12.7132L1.5 36Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 12.2132V36L12.5 24.7868V1L1.5 12.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 36V12.2132L36.5 1V24.7868L25.5 36Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 12H1.5L12.7132 1H36.5L25.2868 12Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="12"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 11H82.5V35H58.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46H71.2868L82.5 35H58.7132L47.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 22.2132V46L58.5 34.7868V11L47.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46V22.2132L82.5 11V34.7868L71.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 22H47.5L58.7132 11H82.5L71.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 22H71.5V46H47.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57H60.2868L71.5 46H47.7132L36.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 33.2132V57L47.5 45.7868V22L36.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57V33.2132L71.5 22V45.7868L60.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 33H36.5L47.7132 22H71.5L60.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="33"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 33H60.5V57H36.5V33Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 68H49.2868L60.5 57H36.7132L25.5 68Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 44.2132V68L36.5 56.7868V33L25.5 44.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68V44.2132L60.5 33V56.7868L49.5 68Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 44H25.5L36.7132 33H60.5L49.2868 44Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="44"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 11H106.5V35H82.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46H95.2868L106.5 35H82.7132L71.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 22.2132V46L82.5 34.7868V11L71.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 46V22.2132L106.5 11V34.7868L95.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 22H71.5L82.7132 11H106.5L95.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 22H95.5V46H71.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57H84.2868L95.5 46H71.7132L60.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 33.2132V57L71.5 45.7868V22L60.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 57V33.2132L95.5 22V45.7868L84.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 33H60.5L71.7132 22H95.5L84.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="33"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 33H84.5V57H60.5V33Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68H73.2868L84.5 57H60.7132L49.5 68Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 44.2132V68L60.5 56.7868V33L49.5 44.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 68V44.2132L84.5 33V56.7868L73.5 68Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 44H49.5L60.7132 33H84.5L73.2868 44Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="44"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function EmptyPromotionDrawer() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="119"
      viewBox="0 0 120 119"
    >
      <rect
        x="5.5"
        y="5"
        width="109"
        height="109"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="1"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="1.5"
        y="110"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="110.5"
        y="1"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="110.5"
        y="110"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <path
        d="M75 95V45L95 24V74.0107L75 95Z"
        fill="#A1E5E5"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M75 45H25L45.3303 24H95L75 45Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25"
        y="45"
        width="50"
        height="50"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
